/* FL Sales Pause: okno z informacja o przerwie w sprzedazy (natywny <dialog>).
   Otwiera sie po opoznieniu, o ile termin przerwy nie minal i klient nie
   zamknal okna w ciagu ostatnich N godzin (cookie, N z ustawien sekcji).
   Po wyslaniu formularza newslettera strona sie przeladowuje — okno otwiera
   sie wtedy ponownie, zeby pokazac wynik zapisu. */
(() => {
  if (customElements.get('fl-sales-pause')) return;

  const SUBMITTED_KEY = 'fl-pause-submitted';

  // sessionStorage bywa zablokowany (tryb prywatny) — wtedy po prostu nie pokazemy wyniku zapisu
  const takeSubmitted = () => {
    try {
      const submitted = sessionStorage.getItem(SUBMITTED_KEY) !== null;
      sessionStorage.removeItem(SUBMITTED_KEY);
      return submitted;
    } catch (e) {
      return false;
    }
  };

  const markSubmitted = () => {
    try {
      sessionStorage.setItem(SUBMITTED_KEY, '1');
    } catch (e) { /* patrz wyzej */ }
  };

  class FlSalesPause extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      // nowy termin = nowe cookie, wiec zmiana dat pokazuje okno takze tym, ktorzy zamkneli poprzednie
      this.cookie = `fl-pause-${this.dataset.from}-${this.dataset.to}`.replace(/[^\w-]/g, '');
      this.bindDialog();

      const submitted = takeSubmitted();
      const result = this.querySelector('[data-fl-pause-result]');
      // Shopify oznacza wynik na kazdym formularzu newslettera na stronie (takze po zapisie
      // w stopce) — pokazujemy go tylko wtedy, gdy wyslano formularz z tego okna
      if (result && !submitted) result.hidden = true;
      const showResult = Boolean(result) && submitted;
      if (showResult) this.classList.toggle('is-subscribed', result.dataset.flPauseResult === 'ok');

      if (window.Shopify && Shopify.designMode) {
        this.bindEditor();
      } else if (showResult) {
        this.open();
        result.focus();
      } else if (!this.isExpired() && !this.isDismissed()) {
        this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.unlockScroll();
      if (this.onSelect) {
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
      }
    }

    bindDialog() {
      // klik w tlo zamyka okno tylko wtedy, gdy tam sie zaczal — przeciagniecie zaznaczenia
      // tekstu poza karte konczy sie klikiem na <dialog>, a nie powinno zamykac
      let downOnBackdrop = false;
      this.dialog.addEventListener('pointerdown', (evt) => {
        downOnBackdrop = evt.target === this.dialog;
      });

      this.dialog.addEventListener('click', (evt) => {
        const onBackdrop = evt.target === this.dialog && downOnBackdrop;
        if (onBackdrop || evt.target.closest('[data-fl-pause-close]')) this.dialog.close();
      });

      // 'close' leci takze po Esc
      this.dialog.addEventListener('close', () => {
        this.unlockScroll();
        this.remember();
      });

      // Zamykamy okno juz przy wysylce: modalny <dialog> wylacza reszte strony (inert, top-layer),
      // wiec ewentualne wyzwanie captcha Shopify wstawione do <body> byloby pod nim nieklikalne.
      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', () => {
          markSubmitted();
          this.dialog.close();
        });
      }
    }

    bindEditor() {
      const section = this.closest('.shopify-section');
      this.onSelect = (evt) => {
        if (evt.target === section) this.open();
      };
      this.onDeselect = (evt) => {
        if (evt.target === section && this.dialog.open) this.dialog.close();
      };
      document.addEventListener('shopify:section:select', this.onSelect);
      document.addEventListener('shopify:section:deselect', this.onDeselect);
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      // blokada przewijania wzorem motywu (body.overflow-hidden kompensuje szerokosc paska);
      // zdejmujemy ja tylko, jesli sami ja zalozylismy
      this.lockedScroll = !document.body.classList.contains('overflow-hidden');
      if (this.lockedScroll) document.body.classList.add('overflow-hidden');
    }

    unlockScroll() {
      if (this.lockedScroll) document.body.classList.remove('overflow-hidden');
      this.lockedScroll = false;
    }

    /** Ostatni dzien przerwy liczy sie caly — okno gasnie o polnocy po nim (zegar klienta). */
    isExpired() {
      if (this.dataset.autoHide !== 'true') return false;
      const [year, month, day] = this.dataset.to.split('-').map(Number);
      if (!year || !month || !day) return false;
      return Date.now() >= new Date(year, month - 1, day + 1).getTime();
    }

    isDismissed() {
      return document.cookie.split('; ').some((entry) => entry.startsWith(`${this.cookie}=`));
    }

    remember() {
      if (window.Shopify && Shopify.designMode) return;
      const hours = Number(this.dataset.repeatHours);
      if (hours > 0) {
        document.cookie = `${this.cookie}=1; path=/; max-age=${hours * 3600}; SameSite=Lax`;
      }
    }
  }

  customElements.define('fl-sales-pause', FlSalesPause);
})();
